import { PATH_SEGMENT } from 'routes/pathSegments'

// The calendar locks page scrolling; the Series pages under /schedule/series scroll normally.
export const isSchedulePagePath = (segments: string[]): boolean =>
  segments[1]?.toLowerCase() === PATH_SEGMENT.SCHEDULE &&
  segments[2]?.toLowerCase() !== PATH_SEGMENT.SERIES

// The Series pages lay out their own padding, like the calendar does.
export const isSeriesPagePath = (segments: string[]): boolean =>
  segments[1]?.toLowerCase() === PATH_SEGMENT.SCHEDULE &&
  segments[2]?.toLowerCase() === PATH_SEGMENT.SERIES
